import React from 'react'
import PropTypes from 'prop-types'

// @ts-ignore
import PriorityIcon from "../../../../../gd-components/priority/priority-icon/priority-icon"

// extends React.Component is required because of reference in parent
export default class PriorityMultiselectPopoverOption extends React.Component<any> {

    static propTypes = {
        option          : PropTypes.object,

        isHighlighted   : PropTypes.bool,
        isSelected      : PropTypes.bool,

        onClick         : PropTypes.func,
    }

    onClick = () => {this.props.onClick(this.props.option)}

    render() {
        const classes = Classes('option pill', {
            'highlighted': this.props.isHighlighted
        })

        const valueClasses = Classes('label', {
            bold: this.props.isSelected
        })

        return (
            <div className={classes} onClick={this.onClick}>
                {!!this.props.option.value &&
                    <React.Fragment>
                        <div className={Classes("ui5-cb s-16 fl-no-shrink m-r-10", this.props.className, {selected: this.props.isSelected})}/>
                        <PriorityIcon className="fl-no-shrink m-r-10" priority={this.props.option.value}/>
                    </React.Fragment>}
                <div className={valueClasses}>{this.props.option.label}</div>
            </div>
        )
    }
}